import { billingPayments } from './billing-payments';
import { settings } from './settings';
import { accountAccess } from './account-access';

import {
  account,
  billing,
  insertionOrder,
  payment,
  rebill,
} from './billing-payments-standalone';
import {
  accountSettings,
  managerAccountSettings,
  advancedSettings,
} from './settings-standalone';
import { accountMap } from './account-map-standalone';
import { accountIdentityVerification } from './account-identity-verification-standalone';
import { mandateAgreementRequired } from './mandate-agreement-required-standalone';
import { UKFCAVerification } from './uk-fca-verification-standalone';
import { channelPartner } from './channel-partner-standalone';
import { billingGroupCreation } from './billing-group-creation-standalone';
import { fraudAppeal } from './fraud-appeal-standalone';

export const clientCenterPages = [
  billingPayments,
  settings,
  accountAccess,
];

export const clientCenterStandalonePages = [
  account,
  billing,
  insertionOrder,
  payment,
  rebill,
  accountSettings,
  managerAccountSettings,
  advancedSettings,
  accountMap,
  accountIdentityVerification,
  mandateAgreementRequired,
  UKFCAVerification,
  channelPartner,
  billingGroupCreation,
  fraudAppeal,
];
